module.exports = "/static/assets/b77bd40e28ea6776c9c2b7f365b16cd8.png";